<template>
    <div class="productSort" id="apply">
        <img src="http://tieyige.fsrcwl.cn/images/dian.jpg"
             style="width: 100%; height: 100%"
        />
        <form @submit.prevent="submit($event)" class="tablea">
            <div class="box">
                <ul class="list_box">
                    <li class="m">
                        <input type="text" @blur="fixScroll" class="phone top_list" placeholder="店名" name="shopname" id="shopname">
                    </li>
                    <div class="line"></div>
                    <li class="m">
                        <input type="text" @blur="fixScroll" class="phone top_list" placeholder="姓名" name="username" id="username">
                    </li>
                    <div class="line"></div>
                    <li class="m">
                        <input style="width: 68%;" type="number" @blur="fixScroll" class="phone top_list"
                               placeholder="手机号" name="phone" id="phone">
                        <div class="line_center"></div>
                        <!-- <input style="width: 30%;background-color: #fff;padding:0;color: #696969;" class="phone" type="button" id="btn" @click="getAuthCode" value="验证码"> -->
                        <input style="width: 30%;background-color: #fff;padding:0;color: #696969;" class="phone" type="button" id="btn"  @click="code_num()"  value="验证码">
                        <!-- <span v-show="sendAuthCode" class="auth_text auth_text_blue" @click="getAuthCode">获取验证码</span>
            <span v-show="!sendAuthCode" class="auth_text"> <span class="auth_text_blue">{{auth_time}} </span> 秒之后重新发送验证码</span>  -->

                    </li>
                    <div class="line"></div>
                    <li class="m">
                        <input type="text" @blur="fixScroll" class="phone top_list" placeholder="验证码" name="code"
                               id="code">
                    </li>
                    <div class="line"></div>
                    <li class="m">
                        <input type="text" @blur="fixScroll" class="phone top_list" placeholder="详细地址" name="address"
                               id="address">
                    </li>
                    <div class="line"></div>
                    <li class="m">
                        <input type="password" @blur="fixScroll" class="phone top_list" placeholder="密码" name="pwd"
                               id="pwd">
                    </li>
                    <div class="line"></div>
                    <li class="m">
                        <input type="password" @blur="fixScroll" class="phone top_list" placeholder="确认密码" name="repwd"
                               id="repwd">
                    </li>
                </ul>
            </div>
            <div class="form-btn">
                <input class="submit" type="submit" value=""/>
            </div>
        </form>
    </div>
</template>
<style scoped>
    .focusState {
        position: absolute;
    }
</style>

<script>
    import "@assets/css/reset.css";
    import "@assets/css/form.css";
    import sendVerifyCode from "@mixins/SendVerifyCode";
    import {createOrder} from "@api/order";
    import { getUser,sendcode, checkphone } from "@api/user";
    import {postCartAdd, getLevel, checkuser, belevel} from "@api/store";

 

    export default {
        name: "Dian",
        mixins: [sendVerifyCode],
        components: {},
        props: {},
        data: function () {
            return {
                userInfo: {},
                wait: 60,
                code: 0,
            };
           
        },
        mounted: function() {
            let that = this;
            getUser().then(res => {
                that.userInfo = res.data;
            });
        },
        methods: {
            submit: function (event) {
                let that = this;
                var shopname = document.getElementById("shopname").value;
                var username = document.getElementById("username").value;
                var phone = document.getElementById("phone").value;
                var code = document.getElementById("code").value;
                var pwd = document.getElementById("pwd").value;
                var repwd = document.getElementById("repwd").value;
                var address = document.getElementById("address").value;
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;

                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                console.log(username);
                
                if (shopname == "") {
                    alert("请输入店名");
                    return;
                }
                if (username == "") {
                    alert("请输入姓名");
                    return;
                }
                if (phone == "") {
                    alert("请输入手机号");
                    return;
                }
                if (!(/^1[3456789]\d{9}$/.test(phone))) {
                    alert("手机号码有误，请重填");
                    return false;
                }
                if (code == "") {
                    alert("请输入验证码");
                    return;
                }
                if (address == ''){
                    alert("请输入地址");
                    return;
                }
                if (code != that.code) {
                    alert("验证码不正确");
                    return;
                }
                if (pwd == "") {
                    alert("请输入密码");
                    return;
                }
                if (repwd == "") {
                    alert("请输入确认密码");
                    return;
                }
                if (repwd != pwd) {
                    alert("两次密码不一样");
                    return;
                }

                let w = {
                    mobile: phone,
                };
                checkphone(w)
                    .then(res => {
                        console.log(res);
                        if (parseInt(res.msg) == 0){
                            alert("手机号已注册");
                            return;
                        }else {
                            checkuser()
                                .then(res => {
                                    console.log(res);
                                    if (parseInt(res.msg) == 0){
                                        alert("你已经注册");
                                        return;
                                    }else {

                                        let q = {
                                            productId: 25,
                                            shopname: shopname,
                                            username: username,
                                            phone: phone,
                                            address: address,
                                            pwd: pwd,
                                            uid: that.userInfo.uid,
                                            type:0
                                        };
                                        belevel(q)
                                            .then(function(res) {
                                                alert("信息提交成功")
                                                console.log("------postCartAdd------");
                                                console.log(res.data.cartId);
                                                that.$router.push({ path: "/shenhe"});

                                            })
                                            .catch(res => {
                                                that.isOpen = false;
                                                return that.$dialog.toast({ mes: res.msg });
                                            });

                                    }
                                });
                        }
                    });

            },

            code_num: function() {
                console.log("================");
                var that = this;

                var mobile = document.getElementById("phone").value;
                if (mobile == "") {
                    alert("请输入手机号码");
                    return;
                }

                if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(mobile))) {
                    alert("手机号码有误，请重填");
                    return;
                }


                let w = {
                    mobile: mobile,
                };
                checkphone(w)
                    .then(res => {
                        console.log(res);
                        if (parseInt(res.msg) == -1){

                            this.time_out(this);

                            let u = {
                                mobile: mobile,
                            };
                            sendcode(u)
                                .then(res => {
                                    console.log(res.data.code);
                                    that.code = res.data.code;
                                })
                        }else {
                            alert("手机号已注册");
                            return;
                        }

                    });

            },

            time_out: function(o) {
                console.log("=======time_out=========");
                var that = this;
                var btn = document.getElementById("btn");
                if (that.wait == 0) {
                    btn.removeAttribute("disabled");
                    btn.value = "再次获取";
                    that.wait = 60;
                } else {
                    btn.setAttribute("disabled", true);
                    btn.value = "重获(" + that.wait + ")秒";
                    that.wait--;
                    setTimeout(function () {
                            that.time_out(btn)
                        },
                        1000)
                }
            },

            mounted() {
                console.log("----mounted------");

                var a = document.getElementsByTagName('input');

                for (let i = 0; i < a.length; i++) {
                    a[i].addEventListener('blur', this.fixScroll);
                }
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            },

            destroyed() {
            },

            methods: {
                fixScroll() {
                    window.scrolll(0, 0);
                }
            },


            if (isIos) {
                $('input,textarea').on('blur', function () {
                    window.scroll(0, 0);
                });
                $('select').on('change', function () {
                    window.scroll(0, 0);
                });
            },

            created(){
                console.log("----created------");
                var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
                window.onresize = function () {
                    var nowClientHeight = document.documentElement.clientHeight || document.body.clientHeight;
                    if (clientHeight - nowClientHeight > 60) {//因为ios有自带的底部高度
                        //键盘弹出的事件处理
                        document.getElementById("apply").classList.add("focusState");
                    }
                    else {
                        //键盘收起的事件处理
                        document.getElementById("apply").classList.remove("focusState");
                    }
                };
            },
        }
    };
</script>
